import { createReducer, on } from '@ngrx/store';
import { initialState } from './orders.state';
import * as OrdersActions from './orders.actions';

export const ordersReducer = createReducer(
  initialState,
  on(OrdersActions.loadUserOrders, (state, { page }) => ({
    ...state,
    currentPage: page,
    isLoading: true,
    error: null
  })),
  on(OrdersActions.loadUserOrdersSuccess, (state, { orderPage }) => ({
    ...state,
    orders: orderPage.content || [],
    totalElements: orderPage.totalElements,
    totalPages: orderPage.totalPages,
    currentPage: orderPage.number,
    isLoading: false
  })),
  on(OrdersActions.loadUserOrdersFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false
  }))
);
